import styled from 'styled-components';
import Button from 'components/Button';
import {
  border1,
  green,
  lightBlue,
  lightRed,
  lightYellow,
  red,
} from '../../../utils/style/colors';
import { SecurityEventLevel } from 'store/entity/IUserSecurityEvent';

export const FormContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const NameForm = styled('form')`
  align-items: center;
`;

export const PasswordForm = styled('form')`
  display: block;
  align-items: center;
  margin-bottom: 3rem;
`;

interface PasswordHintProps {
  matches: boolean;
}
export const PasswordHint = styled('p')<PasswordHintProps>`
  display: block;
  color: ${(values) => {
    return values.matches ? green : red;
  }};
`;

export const SubmitName = styled(Button)`
  display: block;
`;

export const PhoneForm = styled('form')`
  display: flex;
  flex-direction: column;
`;

export const SubmitPhoneButtons = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const SubmitNumber = styled(Button)`
  margin: 0.6rem 0 !important;
`;

export const LogItems = styled.ul`
  margin: 10px;
  border-radius: 10px;
  flex: 1;
  width: 100%;
`;

interface LogItemProps {
  level: SecurityEventLevel;
}

export const LogItem = styled.li<LogItemProps>`
  border: ${border1};
  margin-bottom: 10px;
  display: flex;
  padding: 10px 20px;
  position: relative;
  transition: all 0.3s ease;
  box-sizing: border-box;
  align-items: center;
  border-radius: 10px;
  background-color: ${({ level }) =>
    level === SecurityEventLevel.warn
      ? lightYellow
      : level === SecurityEventLevel.info
        ? lightBlue
        : lightRed};
`;

export const CircleContainer = styled.div`
  background: ${green};
  font-weight: bold;
  color: var(--exact-white);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10rem;
  width: 3rem;
  height: 3rem;
  padding: 0.25rem;
`;
